import { Col, Row, Modal, Input, Form, message, DatePicker, Select } from "antd";
import Title from "../UI/Title/Title";
import { useTranslation } from "react-i18next";
import { useEffect, useState } from "react";
import { postPriceLists } from "../../api/priceLists";
import { useMutation } from "react-query";
import moment from 'moment'
import { PriceListsInterface, WarehouseInterface } from "./Interfaces";
import { getWarehouses } from "../../api/warehouse";

type prop = {
  isAddPriceOpen: boolean;
  setIsAddPriceOpen: React.Dispatch<React.SetStateAction<boolean>>;
  setSaleLists: React.Dispatch<React.SetStateAction<PriceListsInterface[]>>;
  setSaleListsSearch: React.Dispatch<React.SetStateAction<PriceListsInterface[]>>;
};

const AddPrice = ({ isAddPriceOpen, setIsAddPriceOpen, setSaleLists, setSaleListsSearch }: prop) => {
  const [t] = useTranslation("common");
  const [form] = Form.useForm();
  const [name, setName] = useState("");
  const [warehouseId, setWarehouseId] = useState(1); // Default value, replace it with your actual default value
  const [startDate, setStartDate] = useState<string>('');
  const [endDate, setEndDate] = useState<string>('');
  const [warehouses, setWarehouses] = useState<WarehouseInterface[]>([])

  const { mutateAsync: postPriceListsMutation, isLoading: priceListsLoading } = useMutation(
    "postPriceLists",
    ({ name, warehouseId, startDate, endDate }: { name: string; warehouseId: number; startDate: any; endDate: any }) => {
      return postPriceLists({ name, warehouseId, startDate, endDate })
    },
    {
      onSuccess: ({ data }) => {
        message.success(data.message);
        setSaleLists(data.data);
        setSaleListsSearch(data.data);
        setIsAddPriceOpen(false);
      },
      onError: ({ response }) => {
        message.error(response.data.message);
      },
    }
  );

  const { mutateAsync: getWarehousesMutation, isLoading: warehousesLoading } = useMutation(
    "getWarehouses",
    () => {
      return getWarehouses()
    },
    {
      onSuccess: ({ data }) => {
        setWarehouses(data)
      },
      onError: ({ response }) => {
        message.destroy()
        message.error(response.message ? response.message : "failed to load warehouses");
      },
    }
  );

  useEffect(() => {
    if (!isAddPriceOpen) return
    getWarehousesMutation()
  }, [isAddPriceOpen])

  const handleName = (event: React.ChangeEvent<HTMLInputElement>) => {
    setName(event.target.value);
  };

  const handleWarehouseId = (value: number) => {
    setWarehouseId(value);
  };

  const handleStartDate = (date: any, stringDates: any) => {
    const parseDate = moment(stringDates).format('MM/DD/YYYY HH:mm:ss')
    setStartDate(parseDate);
  };

  const handleEndDate = (date: any, stringDates: any) => {
    const parseDate = moment(stringDates).format('MM/DD/YYYY HH:mm:ss')
    setEndDate(parseDate);
  };

  const handleSubmit = () => {
    postPriceListsMutation({ name, warehouseId, startDate, endDate });
  };

  return (
    <>
      <Modal
        centered
        okText={`${t("save")}`}
        open={isAddPriceOpen}
        width={490}
        onCancel={() => setIsAddPriceOpen(false)}
        closable={false}
        maskClosable={false}
        cancelText={`${t("cancel")}`}
        okButtonProps={{
          style: {
            height: "40px",
            background: "#1677FF",
            color: "#fff",
            width: "100px",
            backgroundColor: !name ? "grey" : "",
          },
          disabled: !name,
          loading: priceListsLoading,
        }}
        cancelButtonProps={{
          style: {
            color: "#1677FF",
            border: "1px solid #1677FF",
            height: "40px",
            width: "100px",
          },
        }}
        onOk={handleSubmit}
        destroyOnClose
      >
        <Form form={form} layout="vertical" preserve={false}>
          <Row>
            <Col span={24}>
              <Title title={`${t("price-list")}`} />
            </Col>
            <Col span={24} className="modaltitleEdit">{`${t("add-price-list")}`}</Col>
            <Col span={16}>
              <Form.Item label={t("name")} name="name" rules={[{ required: true, message: `${t("enter-text")}` }]}>
                <Input maxLength={50} placeholder={`${t("enter-name")}`} onChange={handleName} />
              </Form.Item>
              <Form.Item
                label={t("warehouse")}
                name="warehouseId"
                rules={[{ required: true, message: `${t("select-warehouse")}` }]}
              >
                <Select
                  placeholder={`${t("select-warehouse")}`}
                  onChange={(value) => handleWarehouseId(value)}
                  loading={warehousesLoading}
                >
                  {warehouses.map((warehouse) => (
                    <Select.Option key={warehouse.id} value={warehouse.id}>
                      {warehouse.name}
                    </Select.Option>
                  ))}
                </Select>
              </Form.Item>
              <Form.Item label={t("start-date")} name="startDate">
                <DatePicker placeholder={`${t("start-date")}`} onChange={handleStartDate} format={"MM/DD/YYYY"} />
              </Form.Item>
              <Form.Item label={t("end-date")} name="endDate">
                <DatePicker placeholder={`${t("end-date")}`} onChange={handleEndDate} format={"MM/DD/YYYY"} />
              </Form.Item>
            </Col>
          </Row>
        </Form>
      </Modal>
    </>
  );
};

export default AddPrice;
